import e from"react";function t(t){let{children:n,maxWidth:r}=t;return r?/* @__PURE__ */ e.createElement(`div`,{style:{maxWidth:r}},n):n}export{t as ButtonMaxWidthElement};
//# sourceMappingURL=button-max-width-element.js.map